import { headquartersFactoryReadFeatureIds } from '@kop/contracts';
import type { AccessScope } from './auth';
import { featureAccessProjectionStatus, managedFeatureForRoute } from './feature-access-projection';
import { isHeadquartersScope } from './headquarters-site-navigation';

export function isHeadquartersFactoryReadScope(scope: AccessScope) {
  return scope.resource.kind === 'site' && isHeadquartersScope(scope) &&
    scope.capabilities.includes('document:read') && scope.capabilities.includes('records:enterprise-read');
}

/** Discovery only. readFeatures never enters an authoring capability or write-role projection. */
export function canReadHeadquartersFactoryFeature(scope: AccessScope, routeId: string) {
  if (!isHeadquartersFactoryReadScope(scope)) return false;
  const projection = featureAccessProjectionStatus(scope.featureAccess);
  const managed = managedFeatureForRoute(routeId);
  return projection.kind === 'enforced' && managed !== null &&
    headquartersFactoryReadFeatureIds.some(feature => feature === managed) &&
    projection.readFeatures.has(managed);
}
